import './frontpage.scss';
import '../reportErrorForm';
import '../imageThemeUpdate';
import '../structure-page.scss';
import './aside/aside.js';
import './gallery/gallery';
import { applyStructurePreview } from '../../structure-preview/structure-preview';
import { useDraggableTable } from '@templates/components/table/table';

applyStructurePreview();
useDraggableTable('structure-definitionText', '#structure-definitionText .table-wrapper');
